<nav class="navbar navbar-dark navbar-theme-primary px-4 col-12 d-md-none">
    <a class="navbar-brand mr-lg-5" href="../index.html">
        <img class="navbar-brand-dark" src="../volt_1.2/assets/img/brand/light.svg" alt="Volt logo" /> <img class="navbar-brand-light" src="../volt_1.2/assets/img/brand/dark.svg" alt="Volt logo" />
    </a>
    <div class="d-flex align-items-center">
        <button class="navbar-toggler d-md-none collapsed" type="button" data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
    </div>
</nav>

<SideBarMenu currentPage='channels'></SideBarMenu>

<main class="content">

    <TopBarNav></TopBarNav>

<!--
            <div class="preloader bg-soft flex-column justify-content-center align-items-center">
    <img class="loader-element animate__animated animate__jackInTheBox" src="../volt_1.2/assets/img/brand/light.svg" height="60" alt="Volt logo">
</div>
-->

            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div class="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                        <ol class="breadcrumb breadcrumb-dark breadcrumb-transparent">
                          <li class="breadcrumb-item"><a href="/#/"><span class="fas fa-home"></span></a></li>
                          <li class="breadcrumb-item active" aria-current="page">{t.SETTINGS.toLowerCase()}</li>
                        </ol>
                    </nav>
                    <h2 class="h4">{t.SETTINGS}</h2>
                    <p class="mb-0"></p>
                </div>
            </div>

            {#if message.level}
            <div class="alert alert-{message.level}" role="alert">
                {message.text}
            </div>
            {/if}

            <div class="card card-body border-light shadow-sm table-wrchanneler table-responsive">
                <h2 class="h5 mb-4">{t.GENERAL_INFO}</h2>
                <div class="row mb-3">
                    <div class="col-md-4">
                        <label for="channel_name" class="form-label">{t.EMAIL}</label>
                        <input type="text" class="form-control" placeholder="Your email" bind:value={$stApp.user.login} >
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <label for="password_change" class="form-label">{t.PASSWORD}</label>
                        {#if !showPwdChange}
                        <button class="btn btn-primary btn-sm" on:click={()=>showPwdChange=true}>{t.PASSWORD_CHANGE}</button>
                        {:else}
                        <input type="password" class="form-control" placeholder="Enter current password" autocomplete="new-password" bind:value={pwd0} >
                        <div style="height: 10px;"></div>
                        <input type="password" class="form-control" placeholder="Enter new password" bind:value={pwd1} >
                        <div style="height: 10px;"></div>
                        <input type="password" class="form-control" placeholder="Confirm new password" bind:value={pwd2} >
                        <div style="height: 10px;"></div>
                        <button class="btn btn-primary btn-sm" on:click={savePassword}>{t.SAVE}</button>
                        <button class="btn btn-outline-primary btn-sm" on:click={()=>showPwdChange=false}>{t.CANCEL}</button>
                        {/if}
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <label for="user_license_key" class="form-label">{t.LICENSE_KEY}</label>
                        <p>{$stApp.user.license_key}</p>
                    </div>
                </div>

                <h2 class="h5 my-4">{t.APP_PREFS}</h2>
                <div class="row mb-3">
                    <div class="col-md-2">
                        <label for="sel_lang">{t.LANGUAGE}</label>
                        <select id="sel_lang" class="form-select mb-0" bind:value={$stApp.user.settings.lang}>
                            <option value="en">English</option>
                            <option value="fr">Français</option>
                        </select>
                    </div>
                </div>

                <h2 class="h5 my-4">Addin XLbroadcaster</h2>
                <div class="row mb-3">
                    <div class="col-md-4">
                        <label for="xlbcuser_license_key">{t.LICENSE_KEY}</label>
                        <p>{xlbc_user.license_key}</p>
                    </div>
                </div>
                <div class="row mb-6">
                    <div class="col-md-6">
                        <label for="xlbcuser_pubkey">{t.PUBKEY}</label>
                        <p>{xlbc_user.pubkey}</p>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-4 mt-auto">
                        <button class="btn btn-primary" on:click={saveUserSettings}>{t.SAVE}</button>
                    </div>
                </div>

            </div>
            
    <BottomFooter></BottomFooter>
</main>


<script>
    import {format as dtfns_format, formatISO9075, parseISO} from 'date-fns'
    import {push} from 'svelte-spa-router'

    import {DBC_URL, stLang} from '../store.js'
    import {axiosPost} from '../c0utils.js'

    import {stApp} from '../dbclib/App.js'
    import {User} from '../dbclib/User.js'

    import BottomFooter from '../comp/BottomFooter.svelte'
    import SideBarMenu from '../comp/SideBarMenu.svelte'
    import TopBarNav from '../comp/TopBarNav.svelte'

    console.log("LANG: ", $stApp.user.settings.lang)
    $: t = $stLang[$stApp.user.settings.lang]

    let showPwdChange = false
    let pwd0 = ""
    let pwd1 = ""
    let pwd2 = ""

    if(!$stApp.user.settings) {
        $stApp.user.settings = {
            lang: 'en'
        }
    }

    const message = {
        level: '',
        text: ''
    }

    let xlbc_user = {
        license_key: 'Not available',
        pubkey: 'Not available'
    }

    requestUser()
    requestXLBCUser()

    async function requestUser() {
        axiosPost(DBC_URL + '/user', {})
        .then((result) => {
            console.log("/user", result.data)
            if(result.ok) $stApp.user = result.data
        })
    }

    async function saveUserSettings() {
        axiosPost(DBC_URL + '/user/settings/save', {
            USER: {
                settings: $stApp.user.settings
            }
        })
        .then((result) => {
            console.log("LANG: ", $stApp.user.settings.lang)
            if(result.ok) { message.level = 'success'; message.text = t[result.success_msg] }
        })
    }

    async function requestXLBCUser() {
        axiosPost(DBC_URL + '/user/xlbc', {})
        .then((result) => {
            console.log("/xlbcuser", result.data)
            if(result.ok) xlbc_user = result.data
        })
    }

    async function savePassword() {
        axiosPost(DBC_URL + '/user/password/save', {
            PWD0: pwd0,
            PWD1: pwd1,
            PWD2: pwd2
        })
        .then((result) => {
            console.log("LANG: ", $stApp.user.settings.lang)
            if(result.ok) { message.level = 'success'; message.text = t[result.success_msg] }
            else { message.level = 'danger'; message.text = t[result.error_msg] }
        })
    }

</script>
